import { ACQUISITION_SOURCES, type AcquisitionSource } from './constants';

export const shuffleAcquisitionSources = (random = Math.random): AcquisitionSource[] => {
  const sources = ACQUISITION_SOURCES.filter((source) => source !== 'other');

  for (let index = sources.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));

    [sources[index], sources[swapIndex]] = [sources[swapIndex], sources[index]];
  }

  return [...sources, 'other'];
};
